//initialize
var modelInitializer = new ModelInitializer();
var TourListModel = modelInitializer.Get("TourList");

// count down function
function getTimeRemaining(endtime) {
  var countDownInterval = setInterval(function () {
    var timeDeff = Date.parse(endtime) - Date.parse(new Date());
    var seconds = Math.floor((timeDeff / 1000) % 60);
    var minutes = Math.floor((timeDeff / 1000 / 60) % 60);
    var hours = Math.floor(timeDeff / (1000 * 60 * 60));
    $(".js-offer-banner-counter").html(`
            <span class="offer-banner__counter-item">${seconds}</span>
            <span class="offer-banner__counter-item">${minutes}</span>
            <span class="offer-banner__counter-item">${hours}</span>
        `);
    if (timeDeff < 0) {
      clearInterval(countDownInterval);
      $(".js-offer-banner-counter").html("<span>پایان</span>");
    }
  }, 1000);
}

window.changeFilter = function (id) {
  masterViewModel.toursFilter.filterViewModel.onChangeSortItemId(id);
}

window.persianMonthNames = [
  'فروردین', 'اردیبهشت', 'خرداد', 'تیر', 'مرداد', 'شهریور', 'مهر', 'آبان', 'آذر', 'دی', 'بهمن', 'اسفند'
]

$(function () {
  if (masterViewModel) {
    window.isFirstFiltering = true;

    masterViewModel.toursFilter = new ToursFilter(TourListModel);

    masterViewModel.toursFilter.start();

    window.onpopstate = function (event) {
      masterViewModel.toursFilter.prepareFilterRequest(window.location.href);

      masterViewModel.toursFilter.sendFilterRequest();
    }
  }

  // sticky side bar
  $(".js-side-bar").theiaStickySidebar({
    additionalMarginTop: 30,
  });

  // filter list show
  $("#js-filter-btn").click(function () {
    $(".js-tour-filter").addClass("show");
    $("html").addClass("no-scroll");
  });

  // filter list show
  $(".js-close-filter").click(function () {
    $(".js-tour-filter").removeClass("show");
    $("html").removeClass("no-scroll");
  });

  // sort list show
  $("#js-sort-btn").click(function () {
    $(".js-tour-sort-list").addClass("show");
    $("html").addClass("no-scroll");
  });

  // filter list show
  $(".js-close-sort").click(function () {
    $(".js-tour-sort-list").removeClass("show");
    $("html").removeClass("no-scroll");
  });
  // init countDown
  getTimeRemaining(new Date("May 15, 2020 15:37:25"));

  $(".js-close-offer-banner").click(function () {
    $(this).closest(".js-offer-banner").slideUp();
  });

  if ($(".js-tour-description>p").height() > 45) {
    $(".js-toggle-details").show();
  }

  //tour-details-toggle
  $(".js-toggle-details").click(function () {
    $(".js-tour-description").toggleClass("destination-show");
    $(this).hide();
  });

  // tour childrens button
  $(".js-tour-childrens-button").click(function () {
    $(this).toggleClass('is-active')
    $(this).closest('li').find('.js-tour-childrens-list').slideToggle("slow")
  })
});
